(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[19388],{

/***/ 37276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ initKakao; },
/* harmony export */   "L": function() { return /* binding */ shareKakao; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97582);


var initKakao = function() {
    if (window.Kakao) {
        var kakao = window.Kakao;
        if (!kakao.isInitialized()) {
            kakao.init("37d6f07b8ece67b826f25e89654bf4e1");
        }
    }
};
var shareKakao = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(linkUrl, title, description) {
        var basicTitle, basicDescription, image, sendTitle, sendDescription, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    basicTitle = "인공지능 서비스 마켓 아이소";
                    basicDescription = "이미지, 데이터 분석 등 다양한 아이소 앱을 사용해보세요.";
                    image = "https://firebasestorage.googleapis.com/v0/b/aiso-api.appspot.com/o/apps%2Fpreview%2Faiso_logo.jpg?alt=media&token=e6014be6-b135-4fdf-bac2-9e86295ffac5";
                    sendTitle = title ? title : basicTitle;
                    sendDescription = description ? description : basicDescription;
                    _tmp = {};
                    /* sendDefault */ return [
                        4,
                        window.Kakao.Link.sendDefault((_tmp.objectType = "feed", _tmp.content = {
                            title: sendTitle,
                            description: sendDescription,
                            imageUrl: image,
                            imageWidth: 1500,
                            imageHeight: 600,
                            link: {
                                mobileWebUrl: linkUrl,
                                webUrl: linkUrl
                            }
                        }, _tmp.buttons = [
                            {
                                title: "아이소로 이동하기",
                                link: {
                                    mobileWebUrl: linkUrl,
                                    webUrl: linkUrl
                                }
                            }, 
                        ], _tmp))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function shareKakao(linkUrl, title, description) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 88087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ PreviewStorageUrl; }
/* harmony export */ });
// import { useState, useEffect } from "react";
// import { projectStorage } from "components/ProjectStorage";
var PreviewStorageUrl = function(previewInput, previewOutput) {
    // const [previewInputFile, setPreviewInputFile] = useState();
    // const [previewOutputFile, setPreviewOutputFile] = useState();
    // const [previewInputFile, setPreviewInputFile] = useState("/images/market/no-img.png");
    // const [previewOutputFile, setPreviewOutputFile] = useState("/images/market/no-img.png");
    // useEffect(() => {
    //   if (previewInput) getFileUrl("input", previewInput);
    //   if (previewOutput) getFileUrl("output", previewOutput);
    // }, [previewInput, previewOutput]);
    // /* image url 가져오기 */
    // const getFileUrl = (type, paramUrl) => {
    //   const storageFileRef = projectStorage.ref(paramUrl);
    //   storageFileRef
    //     .getDownloadURL()
    //     .then((url) => {
    //       try {
    //         if (type === "input") setPreviewInputFile(url);
    //         if (type === "output") setPreviewOutputFile(url);
    //       } catch (e) {
    //         console.log(e);
    //       }
    //     })
    //     .catch((error) => {
    //       console.log("error : ", error);
    //       return { previewInputFile, previewOutputFile };
    //     });
    // };
    var previewInputFile = "/images/market/no-img.png";
    var previewOutputFile = "/images/market/no-img.png";
    if (previewInput) previewInputFile = "https://firebasestorage.googleapis.com/v0/b/aiso-api.appspot.com/o/" + encodeURIComponent(previewInput) + "?alt=media";
    if (previewOutput) previewOutputFile = "https://firebasestorage.googleapis.com/v0/b/aiso-api.appspot.com/o/" + encodeURIComponent(previewOutput) + "?alt=media";
    return {
        previewInputFile: previewInputFile,
        previewOutputFile: previewOutputFile
    };
};


/***/ }),

/***/ 37915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79794);




var UserName = function(email) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""), name = ref[0], setName = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var docRef, docValue, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!email) return [
                        3,
                        4
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    docRef = components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_1__/* .projectFirestore.collection */ .H.collection("users").doc(email);
                    return [
                        4,
                        docRef.get()
                    ];
                case 2:
                    docValue = _state.sent();
                    if (docValue.exists) {
                        if (docValue.data().name !== "") setName(docValue.data().name);
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        email
    ]);
    return name;
};
/* harmony default export */ __webpack_exports__["Z"] = (UserName);


/***/ }),

/***/ 20137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79794);




var UserUid = function(email) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""), uid = ref[0], setUid = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var docRef, docValue, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!email) return [
                        3,
                        4
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    docRef = components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_1__/* .projectFirestore.collection */ .H.collection("users").doc(email);
                    return [
                        4,
                        docRef.get()
                    ];
                case 2:
                    docValue = _state.sent();
                    if (docValue.exists) {
                        if (docValue.data().id !== "") setUid(docValue.data().id);
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        email
    ]);
    return uid;
};
/* harmony default export */ __webpack_exports__["Z"] = (UserUid);


/***/ }),

/***/ 55526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_icons_Share__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53093);
/* harmony import */ var components_modal_ShareModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76195);
/* harmony import */ var _material_ui_core_Tooltip__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(868);
/* harmony import */ var components_UserPhoto__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64410);
/* harmony import */ var components_UserName__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37915);
/* harmony import */ var components_UserUid__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20137);



// Modal







var CardAppDevelopmentInfo = function(param) {
    var appId = param.appId, email = param.email, createdAt = param.createdAt, handleOpen = param.handleOpen, open = param.open, handleClose = param.handleClose, appName = param.appName, oneLineContent = param.oneLineContent;
    /* 사용자 프로필 가져오기 */ var photoUrl = (0,components_UserPhoto__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(email);
    var name = (0,components_UserName__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(email);
    var userUid = (0,components_UserUid__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(email);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex items-center justify-between p-3 market-card-footer",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: {
                    pathname: "/user/profile/[id]",
                    query: {
                        id: userUid
                    }
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex justify-start items-center whitespace-pre-line break-all",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "img-cover-box w-11 h-11 rounded-full bg-white border-2 border-white",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: photoUrl,
                                    alt: "profile"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "ml-2",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "truncate-1-lines mb-0 text-black font-gmarket-medium text-sm",
                                    children: name
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "mb-0 text-333 font-gmarket-medium text-xs",
                                    children: createdAt.substring(0, 16)
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Tooltip__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                        title: "공유하기",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            color: "primary",
                            onClick: handleOpen,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Share__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                className: "text-black"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_modal_ShareModal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        open: open,
                        handleClose: handleClose,
                        path: "/user/market/".concat(appId),
                        title: appName,
                        description: oneLineContent
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CardAppDevelopmentInfo);


/***/ }),

/***/ 30675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var CardCredit = function(param) {
    var useCount = param.useCount, price = param.price;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "px-3 pb-3 flex items-end justify-between",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                className: "text-sm text-333",
                children: [
                    useCount ? useCount : "0",
                    " 회 사용"
                ]
            }),
            Number(price) === 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-ss text-333",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "font-bold text-base text-black",
                    children: "Free"
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                className: "text-ss text-333",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "font-bold text-sm text-primary",
                        children: price
                    }),
                    " Credit"
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CardCredit);


/***/ }),

/***/ 22600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var CardOneLineContent = function(param) {
    var appName = param.appName, content = param.content;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "p-3",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "truncate-1-lines text-black text-lg font-bold my-2",
                children: appName
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "truncate-2-lines text-333 text-sm mb-3",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: content
                    }
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CardOneLineContent);


/***/ }),

/***/ 76195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(80366);
/* harmony import */ var _material_ui_icons_Facebook__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(83792);
/* harmony import */ var _material_ui_icons_Twitter__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(44704);
/* harmony import */ var _material_ui_icons_Link__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(66081);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_Alert__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34950);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74855);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var components_KakaoShare__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37276);
/* harmony import */ var components_modal_MaterialModal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81268);






// ShareIcon








var ShareModal = function(param) {
    var open = param.open, handleClose = param.handleClose, path = param.path, title = param.title, description = param.description;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    // const basicUrl = "aiso-api.du.r.appspot.com";
    var basicUrl = "aiso.ai";
    var linkUrl = path ? basicUrl.concat(path) : basicUrl.concat(router.asPath);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        (0,components_KakaoShare__WEBPACK_IMPORTED_MODULE_5__/* .initKakao */ .$)();
    }, []);
    var handleKakaoShare = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function() {
            var sendLinkUrl;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
                sendLinkUrl = "https://".concat(linkUrl);
                (0,components_KakaoShare__WEBPACK_IMPORTED_MODULE_5__/* .shareKakao */ .L)(sendLinkUrl, title, description);
                return [
                    2
                ];
            });
        });
        return function handleKakaoShare() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_modal_MaterialModal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        open: open,
        closeModal: handleClose,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "popup-content max-w-xl",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "popup-header",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "h-full",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            "aria-label": "close",
                            className: "w-15 h-15",
                            onClick: handleClose,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "popup-body flex flex-col justify-center items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                            className: "text-333 font-gmarket-medium text-2xl font-bold mb-4",
                            children: "Share"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "row w-full",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-6 col-sm-3",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "share-card p-3",
                                        onClick: function() {
                                            handleClose();
                                            // const linkUrl = `aiso-api.du.r.appspot.com${router.asPath}`;
                                            window.open("https://www.facebook.com/sharer.php?u=" + encodeURIComponent(linkUrl));
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "face-share-icon",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Facebook__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                    fontSize: "large"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "mb-0 font-gmarket-medium text-xs text-888 mt-3",
                                                children: "facebook"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-6 col-sm-3",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "share-card p-3",
                                        onClick: handleKakaoShare,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "kakao-share-icon",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    style: {
                                                        width: "40px",
                                                        height: "40px"
                                                    },
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        className: "p-1",
                                                        src: "/images/market/kakaotalk.svg",
                                                        alt: ""
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "mb-0 font-gmarket-medium text-xs text-888 mt-3",
                                                children: "Kakao Talk"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-6 col-sm-3",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "share-card p-3",
                                        onClick: function() {
                                            handleClose();
                                            window.open("https://twitter.com/intent/tweet/?url=" + encodeURIComponent(linkUrl));
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "twitter-share-icon",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Twitter__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                    fontSize: "large"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "mb-0 font-gmarket-medium text-xs text-888 mt-3",
                                                children: "Twitter"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-6 col-sm-3",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_4__.CopyToClipboard, {
                                        text: "https://".concat(linkUrl),
                                        onCopy: function() {
                                            (0,components_Alert__WEBPACK_IMPORTED_MODULE_3__/* .BasicAlert */ .N)("클립보드에 복사되었습니다.");
                                            handleClose();
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "share-card p-3",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "twitter-share-icon",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Link__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                        fontSize: "large"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "mb-0 font-gmarket-medium text-xs text-888 mt-3",
                                                    children: "Copy Link"
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "popup-footer"
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ShareModal);


/***/ }),

/***/ 73180:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 18104:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 73731:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 4059:
/***/ (function() {

/* (ignored) */

/***/ })

}]);